import { demo } from 'api/demo';
import { reqLogout } from "api/login";
import { productType } from "config/config";
import { debounce } from "utils/util";
import { reqGetInformation } from "api/personal-center";

import store from 'store';

export function _demo({ commit }) {
    return demo()
    .then( response => {
      if (response.code === 200) {
        commit('SET_DEMO', response.data)
      }
    }) 
}

/** 
 * 获得用户信息 
 */
export const getUserInfo = debounce(({ commit }) => {
  let obj = {};
  return reqGetInformation(obj).then(res => {
    if(res.code === 0) {
      commit('SET_USER', res.data)
    }
  }).catch(err => {
    console.log('获取基本资料失败', err);
  });
}, 300);

/** 
 * 退出登录 
 */
export function setLogout({ commit, vm }) {
  let obj = {};
  return reqLogout(obj).then(res => {
    if(res.code === 0) {
      commit('LOGOUT', res.data);
    }
  }).catch(err => {
    console.log('获取基本资料失败', err);
  });
}
